export const slugify = (value) => value
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
export const prettify = (value) => {
    return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`.replaceAll('-', ' ').replaceAll('_', ' ');
};
export const uglify = (value) => {
    return value.replaceAll('-', '_').toUpperCase();
};
export const abbreviate = (value) => {
    return value
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase())
        .join('')
        .slice(0, 2);
};
export const fromSnakeToCamel = (value) => {
    return value.replace(/_./g, (x) => x[1].toUpperCase());
};
//# sourceMappingURL=string.js.map